<template>
  <div class="min-h-screen bg-gray-900 text-gray-100 px-4">
    <!-- Page Title -->
    <div class="py-6 text-center">
      <h1 class="text-4xl font-bold text-white">Pending Verifications</h1>
    </div>

    <!-- Search Bar -->
    <div class="mb-6 flex justify-center">
      <input
        v-model="search"
        type="text"
        placeholder="Search by name or account"
        class="w-full max-w-lg px-4 py-2 text-gray-900 rounded-md bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    </div>

    <!-- Table of Accounts -->
    <div class="overflow-x-auto">
      <table class="w-full max-w-lg mx-auto bg-gray-800 rounded-lg shadow-lg">
        <thead>
        <tr class="text-left border-b border-gray-600">
          <th class="py-3 px-6 text-sm font-semibold text-gray-200">S.No</th>
          <th class="py-3 px-6 text-sm font-semibold text-gray-200">Name</th>
          <th class="py-3 px-6 text-sm font-semibold text-gray-200">Gender</th>
          <th class="py-3 px-6 text-sm font-semibold text-gray-200">Nationality</th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="item in filteredData()"
          :key="item.id"
          class="border-b border-gray-700 hover:bg-gray-700 cursor-pointer"
          @click="openModal(item)"
        >
          <td class="py-4 px-6 text-sm text-gray-300">{{ getOriginalIndex(item) + 1 }}</td>
          <td class="py-4 px-6 text-sm text-gray-300">{{ item.fullName }}</td>
          <td class="py-4 px-6 text-sm text-gray-300">{{ item.gender }}</td>
          <td class="py-4 px-6 text-sm text-gray-300">{{ item.nationality }}</td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- View profile -->
    <ViewProfile
        v-if="selectedUser"
        :cache="cache"
        :request="request"
        :record="selectedUser"
        @closeModal="closeModal"
        @verifyRecord="verifyRecord"
    />
  </div>
</template>

<script>
import CacheManager from "@/utils/CacheManager";
import {RequestManager} from "@/utils/RequestManager";
import ViewProfile from '@/components/ui/ViewProfile.vue';
import EventBus from "@/utils/EventBus";

export default {
  name: "DashboardPage",
  components: { ViewProfile },
  emits: [],
  props: {
    role: {
      type: Number,
      required: true,
    },
    cache: {
      type: CacheManager,
      required: true,
    },
    request: {
      type: RequestManager,
      required: true,
    },
    records: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      search: "",
      selectedUser: null,
    };
  },
  methods: {
    async verifyRecord(mediaItems) {
      try {
        const verifyInfo = {
          rejected: [],
          approved: true,
          isID: this.isID,
        };
        for (const mediaItem of mediaItems) {
          const status = mediaItem.status;
          if(status === "Approved") continue;
          verifyInfo.rejected.push(mediaItem.label);
          verifyInfo.approved = false;
        }
        EventBus.emit('completedRecord', {
          record: this.record,
          verifyInfo: verifyInfo,
        });
      }
      catch (error) {
        console.error("Verification submission failed:", error);
      }
      finally {
        this.isLoading = false;
      }
    },
    filteredData() {
      const search = this.search.toLowerCase();
      return this.records.filter(
        (item) => {
          const fullName = item.fullName || '';
          // const residence = item.residence || '';
          const gender = item.gender || '';
          const nationality = item.nationality || '';
          if(!fullName.length) return false;
          return fullName.toLowerCase().includes(search) ||
              gender.toLowerCase().includes(search) ||
              nationality.toLowerCase().includes(search)
          }
        );
    },
    getOriginalIndex(item) {
      // Find the index of the item in the original passports array
      return this.records.findIndex((originalItem) => originalItem.id === item.id);
    },
    openModal(passport) {
      this.selectedUser = { ...passport };
    },
    closeModal() {
      this.selectedUser = null;
    },
    deletePassport(id) {
      // Trigger delete logic here
      this.$emit("delete", id);
      this.closeModal();
    },
    updatePassport(updatedPassport) {
      // Trigger update logic here
      this.$emit("update", updatedPassport);
      this.closeModal();
    },
  },
};
</script>

<style scoped>
.table-container {
  max-width: 600px;
  margin: 0 auto;
}
</style>
